// extracted by mini-css-extract-plugin
export default {"appointment-item":"WaitingListVisitItem_appointment-item__0A8hV","appointmentItem":"WaitingListVisitItem_appointment-item__0A8hV"};